export const defaultLetter = {
    name: "example",
    letterId: null,
    subjectFI: "Ilmoitus verkkolaskuosoitteen muutoksesta",
    textFI: 
    `<h2>Hyvä vastaanottaja,</h2><br>
    <p>Yrityksemme on siirtynyt ostolaskujen automaattiseen käsittelyyn ja toivomme teidän jatkossa lähettävän meille osoitetut laskut, joko <u>verkkolaskuina</u> tai <u>uuteen laskutusosoitteeseemme</u>.</p>
    <p>Verkkolaskut meille tulee lähettää osoitteella:</p>
    <p><strong>Verkkolaskuosoite: __OVT_ID__</strong></p>
    <p><strong>Välittäjäntunnus: 003723327487 (TAI 00372332748700001)</strong></p>
    <p><strong>OVT-tunnus: __OVT_ID__</strong></p>
    <br>
    <p>	Jos käytätte pankkien e-lasku palveluita lähetykseen tarkistakaa käytettävä verkkolaskuosoite ja välittäjätunnus täältä:</p>
    <p>	<a href="http://www.apix.fi/ohje.html" rel="noopener noreferrer" target="_blank"><u>http://www.apix.fi/ohje.html</u></a></p>
    <br>
    <p>Erityisesti pankkien kautta lähetettäessä huomioittehan, että laskulla tulee olla yrityksemme y-tunnus: __BUSINESS_ID__.</p>
    <br>
    <p>Uusi laskutusosoitteemme on:</p>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p><strong>@__ETAG__@</strong></p>
    <p><strong>PL 1000</strong></p>
    <p><strong>00781 HELSINKI</strong></p>
    <br>
    <p>Laskutusosoitteeseen tulee lähettää vain laskuja. Muu posti tulee edelleen lähettää osoitteeseen:</p>
    <p>__BUSINESS_NAME__</p>
    <p>__STREET__</p>
    <p>__POSTCODE__ __POSTOFFICE__</p>
    <p><br></p><p> </p>
    <p>Mikäli teillä on laskujen lähettämiseen liittyviä teknisiä kysymyksiä voitte olla yhteydessä verkkolaskuoperaattoriimme: Apix Messaging Oy, (09) 4289 1324, <a href="mailto:servicedesk@apixmessaging.com" rel="noopener noreferrer" target="_blank"><u>servicedesk@apixmessaging.com</u></a></p>
    <br>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p>__CONTACT_PERSON__</p>
    <p>__PHONE__, __EMAIL__</p>`,
    subjectSV: "Notification about changing e-invoiceaddress",
    textSV: `
    <h2>Ärade mottagare,</h2><br>
    <p>Vårt Företag har övergått till elektronisk hantering av inköpsfakturor. Vi önskar att Ni i fortsättningen skickar fakturor adresserade till oss som <u>nätfaktura</u> eller till vår nya <u>faktureringsadress</u>. </p>
    <p>Adress för nätfakturor är:</p>
    <p><strong>Nätfaktureringsadress: </strong></p>
    <p><strong>OVT-TUNNUS __OVT_ID__</strong></p>
    <p><strong>Förmedlarkod: 003723327487 (Eller 00372332748700001)</strong></p>
    <p><strong>OVT-tunnus: __OVT_ID__</strong></p>
    <p>Vid användning av bankernas e-faktura tjänster, vänligen kontrolera att ni använder rätt nätfaktureringsadress (verkkolaskuosoite) och förmedlarkod (välittäjätunnus):</p>
    <p><a href="http://www.apix.fi/ohje.html" rel="noopener noreferrer" target="_blank"><u>http://www.apix.fi/ohje.html</u></a></p>
    <br>
    <p>Observera att fakturan skall ha vårt FO-nummer: yrityksen oma y-tunnus. Detta gäller speciellt vid användning an bankernas tjänster.</p>
    <br>
    <p>Vår nya faktureringsadress är:</p>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p><strong>@__ETAG__@</strong></p>
    <p><strong>PL 1000</strong></p>
    <p><strong>00781 HELSINKI</strong></p>
    <p><strong>FINLAND</strong></p>
    <br>
    <p>Till faktureringsadressen skickas endast fakturor. Övrig post kan fortfarande skickas till adressen:</p>
    <p>__BUSINESS_NAME__</p>
    <p>__STREET__</p>
    <p>__POSTCODE__ __POSTOFFICE__</p>
    <br>
    <p>Om ni har tekniska frågor angående nätfakturering, kan ni även kontakta vår nätfaktureringsoperatör: Apix Messaging Oy, (09) 4289 1324, <a href="mailto:servicedesk@apixmessaging.com" rel="noopener noreferrer" target="_blank"><u>servicedesk@apixmessaging.com</u></a></p>
    <br>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p>__CONTACT_PERSON__</p>
    <p>__PHONE__, __EMAIL__</p>`,
    subjectEN: "Notification about changing e-invoiceaddress",
    textEN: `
    <h2>Dear Sir or Madam,</h2><br>
    <p>Our company has started processing purchase invoices automatically and we would like to receive in the future your invoices either as <u>e-invoices (Verkkolasku)</u> or to our new <u>invoicing address</u>.</p>
    <p><u>e-invoices</u> should be sent using the following address:</p>
    <p><strong>eInvoice address (verkkolaskuosoite): __OVT_ID__</strong></p>
    <p><strong>OperatorID (välittäjätunnus): </strong> <strong>003723327487 </strong>(or alternatively 00372332748700001)</p>
    <p><strong>OVT-tunnus: __OVT_ID__</strong></p>
    <p>If you are using e-Lasku services provided by the Finnish banks, please check the correct eInvoice address (verkkolaskuosoite) and OperatorID (välittäjätunnus) from the following website:</p>
    <p>	<a href="http://www.apix.fi/ohje.html" rel="noopener noreferrer" target="_blank"><u>http://www.apix.fi/ohje.html</u></a></p>
    <p>Especially when using the services of Finnish banks, please make sure that the invoice has our Business ID: yrityksen oma y-tunnus.</p>
    <br>
    <p>Our new <u>invoicing address</u> is:</p>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p><strong>@__ETAG__@</strong></p>
    <p><strong>PL 1000</strong></p>
    <p><strong>00781 HELSINKI</strong></p>
    <p><strong>FINLAND</strong></p>
    <p>Please do not send other correspondence to this address – it is reserved for invoices only. Other correspondence should be sent to the old address:</p>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p>__STREET__</p>
    <p>__POSTCODE__ __POSTOFFICE__</p>
    <p>FINLAND</p>
    <br>
    <p>In case you have any technical questions about sending e-Invoices you can contact our e-Invoicing operator: Apix Messaging Oy, +358 9 4289 1324, <a href="mailto:servicedesk@apixmessaging.com" rel="noopener noreferrer" target="_blank"><u>servicedesk@apixmessaging.com</u></a></p>
    <br>
    <p><strong>__BUSINESS_NAME__</strong></p>
    <p>__CONTACT_PERSON__</p>
    <p>__PHONE__, __EMAIL__</p>`
/*     textDE: `
    <h1>Sehr geehrte Damen und Herren,</h1>
    <p>Unser Unternehmen hat mit der elektronischen Verarbeitung von Eingangsrechnungen begonnen. Wir erhoffen Ihre Rechnungen in der Zukunft als <u>e-Invoices</u> oder <u>postalisch zu unserer neuen Rechnungsadresse</u> zu erhalten. </p>
    <p>Verwenden Sie bitte die folgende e-Invoice -Adresse:</p><p><strong>e-Invoice -Adresse: __OVT_ID__</strong></p>
    <p><strong>Identifikation des Vermittlers: 003723327487 </strong>(Oder 00372332748700001)</p><p><strong>OVT-tunnus: __OVT_ID__</strong></p>
    <p>Sollten Sie Ihre Rechnungen über das ”e-Lasku” –System der finnischen Geschäftsbanken versenden wollen, Bitte überprüfen Sie die korrekte e-Invoice –Adresse (verkkolaskuosoite) und Identifikation des Vermittlers (välittäjäntunnus) unter dem folgenden Link:</p>
    <p><a href="http://www.apix.fi/ohje.html" rel="noopener noreferrer" target="_blank"><u>http://www.apix.fi/ohje.html</u></a></p>
    <br>
    <p>Bitte beachten Sie insbesondere beim Verwenden des finnischen Geschäftsbanken, das  die Rechnung mit unserem Unternehmens ID ausgestattet sein sollte: yrityksen oma y-tunnus.</p>
    <br>
    <p>Unsere neue postalische Rechnungsadresse ist:</p>
    <p>__BUSINESS_NAME__</p>
    <p><strong>@__ETAG__@</strong></p>
    <p><strong>PL 1000</strong></p>
    <p><strong>00781 HELSINKI</strong></p>
    <p><strong>FINLAND</strong></p>
    <br>
    <p>Es sollten nur Rechnungen an die Rechnungsadresse versendet werden. Den restlichen Geschäftsverkehr versenden Sie bitte an die Adresse:</p>
    <p>__BUSINESS_NAME__</p>
    <p>__STREET__</p>
    <p>__POSTCODE__ __POSTOFFICE__</p>
    <p>__COUNTRYCODE__</p>
    <br>
    <p>Sollten Sie Fragen rund um das Thema e-Invoicing haben, ist unserem e-Invoice Dienstleister in Finnland: Apix Messaging Oy, +358 9 4289 1324, <a href="mailto:servicedesk@apix.fi" rel="noopener noreferrer" target="_blank"><u>servicedesk@apix.fi</u></a></p>
    <p><u>__BUSINESS_NAME__</u></p>
    <p>__CONTACT_PERSON__</p>
    <p>__PHONE__, __EMAIL__</p> 
    `*/

}